// Dependencies
import { FC } from "react";

// Components
import { TransactionForm } from "~/components/Layout/LayoutForm";

// Styles
import {
  StyledInfoLabel,
  StyledInfoWrapper,
} from "~/components/Layout/LayoutInfo";
import { TTransactionData } from "~/types";

interface TransactionEditProps {
  initialData: TTransactionData | undefined;
  walletId: string;
  onSubmit: Function;
  onCancel: Function;
}

const TransactionEdit: FC<TransactionEditProps> = (props) => {
  return (
    <StyledInfoWrapper>
      <StyledInfoLabel key={1}>Edit Transaction</StyledInfoLabel>
      <TransactionForm key={2} {...props} />
    </StyledInfoWrapper>
  );
};

export default TransactionEdit;
